'use client';
import type {Dispatch, PropsWithChildren, SetStateAction} from 'react';
import {createContext, Suspense, useEffect, useState} from 'react';

import {Loader} from '@/components/base/Icon';
import InitialLoader from '@/components/InitialLoader';
import PageLoader from '@/components/PageLoader';

import {startOtelInstrumentation} from '../../../.telemetry/frontendTracer';
import authApis from '../services/auth-apis';

type LoaderContextType = {
  isPageLoading: boolean;
  setIsPageLoading: Dispatch<SetStateAction<boolean>>;
};
export const GlobalLoaderContext = createContext({} as LoaderContextType);
export default function GlobalLoaderWrapper({children}: PropsWithChildren) {
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isSessionValidating, setIsSessionValidating] = useState(true);
  if (typeof window !== 'undefined' && process.env.NEXT_PUBLIC_TELEMETRY_DISABLE_ALL === 'false') {
    console.log('Starting telemetry!');
    startOtelInstrumentation();
  }
  useEffect(() => {
    authApis
      .checkSessionState()
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsSessionValidating(false);
      });
  }, []);

  if (isSessionValidating) {
    return <InitialLoader />;
  }

  return (
    <Suspense fallback={<Loader />}>
      <GlobalLoaderContext.Provider value={{isPageLoading, setIsPageLoading}}>
        <PageLoader />
        {children}
      </GlobalLoaderContext.Provider>
    </Suspense>
  );
}
